/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Waypoint
 * Service for managing applications.
 *
 * The version of the OpenAPI document: 2023-08-18
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudWaypointApplicationTemplateToJSON, HashicorpCloudWaypointCheckNamespaceActivationResponseFromJSON, HashicorpCloudWaypointCheckTFCOrganizationResponseFromJSON, HashicorpCloudWaypointCreateActionConfigResponseFromJSON, HashicorpCloudWaypointCreateAddOnDefinitionResponseFromJSON, HashicorpCloudWaypointCreateAddOnResponseFromJSON, HashicorpCloudWaypointCreateApplicationFromTemplateResponseFromJSON, HashicorpCloudWaypointCreateApplicationTemplateResponseFromJSON, HashicorpCloudWaypointCreateNamespaceResponseFromJSON, HashicorpCloudWaypointCreateTFCConfigResponseFromJSON, HashicorpCloudWaypointCreateVariableResponseFromJSON, HashicorpCloudWaypointGetActionConfigResponseFromJSON, HashicorpCloudWaypointGetActionRunResponseFromJSON, HashicorpCloudWaypointGetAddOnDefinitionResponseFromJSON, HashicorpCloudWaypointGetAddOnResponseFromJSON, HashicorpCloudWaypointGetAgentGroupResponseFromJSON, HashicorpCloudWaypointGetApplicationResponseFromJSON, HashicorpCloudWaypointGetApplicationTemplateResponseFromJSON, HashicorpCloudWaypointGetNamespaceResponseFromJSON, HashicorpCloudWaypointGetTFCConfigResponseFromJSON, HashicorpCloudWaypointGetTFModuleDetailsResponseFromJSON, HashicorpCloudWaypointGetTFRunStatusResponseFromJSON, HashicorpCloudWaypointGetTFWorkspaceInfoResponseFromJSON, HashicorpCloudWaypointGetVariableResponseFromJSON, HashicorpCloudWaypointListActionConfigResponseFromJSON, HashicorpCloudWaypointListActionRunsByNamespaceResponseFromJSON, HashicorpCloudWaypointListActionRunsResponseFromJSON, HashicorpCloudWaypointListAddOnDefinitionsResponseFromJSON, HashicorpCloudWaypointListAddOnsResponseFromJSON, HashicorpCloudWaypointListAgentGroupsResponseFromJSON, HashicorpCloudWaypointListApplicationTemplatesResponseFromJSON, HashicorpCloudWaypointListApplicationsResponseFromJSON, HashicorpCloudWaypointListNoCodeModulesResponseFromJSON, HashicorpCloudWaypointListTFAgentPoolsResponseFromJSON, HashicorpCloudWaypointListTFCOrganizationsResponseFromJSON, HashicorpCloudWaypointListTerraformCloudProjectsResponseFromJSON, HashicorpCloudWaypointListVariablesResponseFromJSON, HashicorpCloudWaypointRetrieveAgentOperationResponseFromJSON, HashicorpCloudWaypointRunActionResponseFromJSON, HashicorpCloudWaypointStartingActionResponseFromJSON, HashicorpCloudWaypointUIBulkUpdateActionAssignmentsForAppResponseFromJSON, HashicorpCloudWaypointUICreateActionConfigWithVarsResponseFromJSON, HashicorpCloudWaypointUIGetActionConfigResponseFromJSON, HashicorpCloudWaypointUIGetApplicationBundleResponseFromJSON, HashicorpCloudWaypointUIGetApplicationTemplateBundleResponseFromJSON, HashicorpCloudWaypointUIListActionConfigResponseFromJSON, HashicorpCloudWaypointUIListAddOnDefinitionsResponseFromJSON, HashicorpCloudWaypointUILoadProductBannerResponseFromJSON, HashicorpCloudWaypointUpdateActionConfigResponseFromJSON, HashicorpCloudWaypointUpdateAddOnDefinitionResponseFromJSON, HashicorpCloudWaypointUpdateAddOnResponseFromJSON, HashicorpCloudWaypointUpdateAgentGroupResponseFromJSON, HashicorpCloudWaypointUpdateApplicationResponseFromJSON, HashicorpCloudWaypointUpdateApplicationTemplateResponseFromJSON, HashicorpCloudWaypointUpdateTFCConfigResponseFromJSON, HashicorpCloudWaypointUpdateVariableResponseFromJSON, HashicorpCloudWaypointUpgradeApplicationTFWorkspaceResponseFromJSON, HashicorpCloudWaypointValidateAgentGroupsResponseFromJSON, HashicorpCloudWaypointWaypointServiceCreateActionConfigBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateAddOnBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateAddOnDefinitionBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateAgentGroupBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateApplicationFromTemplateBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateApplicationTemplateBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateNamespaceBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateTFCConfigBodyToJSON, HashicorpCloudWaypointWaypointServiceCreateVariableBodyToJSON, HashicorpCloudWaypointWaypointServiceEndingActionBodyToJSON, HashicorpCloudWaypointWaypointServiceListTFCOrganizationsBodyToJSON, HashicorpCloudWaypointWaypointServiceQueueAgentOperationBodyToJSON, HashicorpCloudWaypointWaypointServiceRetrieveAgentOperationBodyToJSON, HashicorpCloudWaypointWaypointServiceRunActionBodyToJSON, HashicorpCloudWaypointWaypointServiceSendStatusLogBodyToJSON, HashicorpCloudWaypointWaypointServiceStartingActionBodyToJSON, HashicorpCloudWaypointWaypointServiceUIBulkUpdateActionAssignForAppBodyToJSON, HashicorpCloudWaypointWaypointServiceUICreateActionConfigWithVarsBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateActionConfigBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateAddOnBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateAddOnDefinitionBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateAgentGroupBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateApplicationBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateApplicationTemplateBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateTFCConfigBodyToJSON, HashicorpCloudWaypointWaypointServiceUpdateVariableBodyToJSON, HashicorpCloudWaypointWaypointServiceUpgradeApplicationTFWorkspaceBodyToJSON, HashicorpCloudWaypointWaypointServiceValidateAgentGroupsBodyToJSON, } from '../models';
/**
 *
 */
export class WaypointServiceApi extends runtime.BaseAPI {
    /**
     * CheckNamespaceActivation checks the activation status of a namespace based on the TFC token stored in the namespaces database.
     */
    async waypointServiceCheckNamespaceActivationRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCheckNamespaceActivation.');
        }
        const queryParameters = {};
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/check-activation`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCheckNamespaceActivationResponseFromJSON(jsonValue));
    }
    /**
     * CheckNamespaceActivation checks the activation status of a namespace based on the TFC token stored in the namespaces database.
     */
    async waypointServiceCheckNamespaceActivation(namespaceId, force) {
        const response = await this.waypointServiceCheckNamespaceActivationRaw({ namespaceId: namespaceId, force: force });
        return await response.value();
    }
    /**
     * CheckTFCOrganization will use the stored TFC config to look up the TFC Org and look at what permissions it has.
     */
    async waypointServiceCheckTFCOrganizationRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCheckTFCOrganization.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfcconfig/check-organization`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCheckTFCOrganizationResponseFromJSON(jsonValue));
    }
    /**
     * CheckTFCOrganization will use the stored TFC config to look up the TFC Org and look at what permissions it has.
     */
    async waypointServiceCheckTFCOrganization(namespaceId) {
        const response = await this.waypointServiceCheckTFCOrganizationRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     */
    async waypointServiceCreateActionConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateActionConfig.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateActionConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/actionconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateActionConfigBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateActionConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceCreateActionConfig(namespaceId, body) {
        const response = await this.waypointServiceCreateActionConfigRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * CreateAddOn adds an Add-on to a project from an Add-on definition
     */
    async waypointServiceCreateAddOnRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateAddOn.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateAddOn.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateAddOnBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateAddOnResponseFromJSON(jsonValue));
    }
    /**
     * CreateAddOn adds an Add-on to a project from an Add-on definition
     */
    async waypointServiceCreateAddOn(namespaceId, body) {
        const response = await this.waypointServiceCreateAddOnRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * CreateAddOnDefinition creates a new Add-on definition
     */
    async waypointServiceCreateAddOnDefinitionRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateAddOnDefinition.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateAddOnDefinition.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definition`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateAddOnDefinitionBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateAddOnDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * CreateAddOnDefinition creates a new Add-on definition
     */
    async waypointServiceCreateAddOnDefinition(namespaceId, body) {
        const response = await this.waypointServiceCreateAddOnDefinitionRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * CreateAgentGroup creates a new Agent group.
     */
    async waypointServiceCreateAgentGroupRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateAgentGroup.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateAgentGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/group`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateAgentGroupBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * CreateAgentGroup creates a new Agent group.
     */
    async waypointServiceCreateAgentGroup(namespaceId, body) {
        const response = await this.waypointServiceCreateAgentGroupRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * CreateApplicationFromTemplate creates a new Waypoint application from an Application Template, provisioning infrastructure before upserting the Waypoint application to the database
     */
    async waypointServiceCreateApplicationFromTemplateRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateApplicationFromTemplate.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateApplicationFromTemplate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/from-template`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateApplicationFromTemplateBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateApplicationFromTemplateResponseFromJSON(jsonValue));
    }
    /**
     * CreateApplicationFromTemplate creates a new Waypoint application from an Application Template, provisioning infrastructure before upserting the Waypoint application to the database
     */
    async waypointServiceCreateApplicationFromTemplate(namespaceId, body) {
        const response = await this.waypointServiceCreateApplicationFromTemplateRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * CreateApplicationTemplate creates a new application template.
     */
    async waypointServiceCreateApplicationTemplateRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateApplicationTemplate.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateApplicationTemplate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateApplicationTemplateBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * CreateApplicationTemplate creates a new application template.
     */
    async waypointServiceCreateApplicationTemplate(namespaceId, body) {
        const response = await this.waypointServiceCreateApplicationTemplateRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * CreateApplicationTemplate creates a new application template.
     */
    async waypointServiceCreateApplicationTemplate2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateApplicationTemplate2.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateApplicationTemplate2.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateApplicationTemplateBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * CreateApplicationTemplate creates a new application template.
     */
    async waypointServiceCreateApplicationTemplate2(namespaceId, body) {
        const response = await this.waypointServiceCreateApplicationTemplate2Raw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * CreateNamespaces creates an HCP Waypoint namespaces.
     */
    async waypointServiceCreateNamespaceRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling waypointServiceCreateNamespace.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling waypointServiceCreateNamespace.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateNamespace.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/organizations/{location.organization_id}/projects/{location.project_id}/namespaces`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateNamespaceBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateNamespaceResponseFromJSON(jsonValue));
    }
    /**
     * CreateNamespaces creates an HCP Waypoint namespaces.
     */
    async waypointServiceCreateNamespace(locationOrganizationId, locationProjectId, body) {
        const response = await this.waypointServiceCreateNamespaceRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, body: body });
        return await response.value();
    }
    /**
     * CreateTFCConfig creates a Terraform Cloud configuration
     */
    async waypointServiceCreateTFCConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateTFCConfig.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateTFCConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfcconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateTFCConfigBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateTFCConfigResponseFromJSON(jsonValue));
    }
    /**
     * CreateTFCConfig creates a Terraform Cloud configuration
     */
    async waypointServiceCreateTFCConfig(namespaceId, body) {
        const response = await this.waypointServiceCreateTFCConfigRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     */
    async waypointServiceCreateVariableRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceCreateVariable.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceCreateVariable.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/variable`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceCreateVariableBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointCreateVariableResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceCreateVariable(namespaceId, body) {
        const response = await this.waypointServiceCreateVariableRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     */
    async waypointServiceDeleteActionConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteActionConfig.');
        }
        const queryParameters = {};
        if (requestParameters.actionId !== undefined) {
            queryParameters['action_id'] = requestParameters.actionId;
        }
        if (requestParameters.actionName !== undefined) {
            queryParameters['action_name'] = requestParameters.actionName;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/actionconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async waypointServiceDeleteActionConfig(namespaceId, actionId, actionName, force) {
        const response = await this.waypointServiceDeleteActionConfigRaw({ namespaceId: namespaceId, actionId: actionId, actionName: actionName, force: force });
        return await response.value();
    }
    /**
     * DeleteAddOnDefinition deletes an existing Add-on definition
     */
    async waypointServiceDeleteAddOnDefinitionRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteAddOnDefinition.');
        }
        if (requestParameters.addOnDefinitionId === null || requestParameters.addOnDefinitionId === undefined) {
            throw new runtime.RequiredError('addOnDefinitionId', 'Required parameter requestParameters.addOnDefinitionId was null or undefined when calling waypointServiceDeleteAddOnDefinition.');
        }
        const queryParameters = {};
        if (requestParameters.addOnDefinitionName !== undefined) {
            queryParameters['add_on_definition.name'] = requestParameters.addOnDefinitionName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definition/{add_on_definition.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on_definition.id"}}`, encodeURIComponent(String(requestParameters.addOnDefinitionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteAddOnDefinition deletes an existing Add-on definition
     */
    async waypointServiceDeleteAddOnDefinition(namespaceId, addOnDefinitionId, addOnDefinitionName) {
        const response = await this.waypointServiceDeleteAddOnDefinitionRaw({ namespaceId: namespaceId, addOnDefinitionId: addOnDefinitionId, addOnDefinitionName: addOnDefinitionName });
        return await response.value();
    }
    /**
     * DeleteAddOnDefinition deletes an existing Add-on definition
     */
    async waypointServiceDeleteAddOnDefinition2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteAddOnDefinition2.');
        }
        if (requestParameters.addOnDefinitionName === null || requestParameters.addOnDefinitionName === undefined) {
            throw new runtime.RequiredError('addOnDefinitionName', 'Required parameter requestParameters.addOnDefinitionName was null or undefined when calling waypointServiceDeleteAddOnDefinition2.');
        }
        const queryParameters = {};
        if (requestParameters.addOnDefinitionId !== undefined) {
            queryParameters['add_on_definition.id'] = requestParameters.addOnDefinitionId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definition/by-name/{add_on_definition.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on_definition.name"}}`, encodeURIComponent(String(requestParameters.addOnDefinitionName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteAddOnDefinition deletes an existing Add-on definition
     */
    async waypointServiceDeleteAddOnDefinition2(namespaceId, addOnDefinitionName, addOnDefinitionId) {
        const response = await this.waypointServiceDeleteAddOnDefinition2Raw({ namespaceId: namespaceId, addOnDefinitionName: addOnDefinitionName, addOnDefinitionId: addOnDefinitionId });
        return await response.value();
    }
    /**
     * DeleteAgentGroup deletes an agent group.
     */
    async waypointServiceDeleteAgentGroupRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteAgentGroup.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling waypointServiceDeleteAgentGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/group/{name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteAgentGroup deletes an agent group.
     */
    async waypointServiceDeleteAgentGroup(namespaceId, name) {
        const response = await this.waypointServiceDeleteAgentGroupRaw({ namespaceId: namespaceId, name: name });
        return await response.value();
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplateRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteApplicationTemplate.');
        }
        if (requestParameters.applicationTemplateId === null || requestParameters.applicationTemplateId === undefined) {
            throw new runtime.RequiredError('applicationTemplateId', 'Required parameter requestParameters.applicationTemplateId was null or undefined when calling waypointServiceDeleteApplicationTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateName !== undefined) {
            queryParameters['application_template.name'] = requestParameters.applicationTemplateName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates/{application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.id"}}`, encodeURIComponent(String(requestParameters.applicationTemplateId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplate(namespaceId, applicationTemplateId, applicationTemplateName) {
        const response = await this.waypointServiceDeleteApplicationTemplateRaw({ namespaceId: namespaceId, applicationTemplateId: applicationTemplateId, applicationTemplateName: applicationTemplateName });
        return await response.value();
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplate2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteApplicationTemplate2.');
        }
        if (requestParameters.applicationTemplateName === null || requestParameters.applicationTemplateName === undefined) {
            throw new runtime.RequiredError('applicationTemplateName', 'Required parameter requestParameters.applicationTemplateName was null or undefined when calling waypointServiceDeleteApplicationTemplate2.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateId !== undefined) {
            queryParameters['application_template.id'] = requestParameters.applicationTemplateId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates/by-name/{application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.name"}}`, encodeURIComponent(String(requestParameters.applicationTemplateName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplate2(namespaceId, applicationTemplateName, applicationTemplateId) {
        const response = await this.waypointServiceDeleteApplicationTemplate2Raw({ namespaceId: namespaceId, applicationTemplateName: applicationTemplateName, applicationTemplateId: applicationTemplateId });
        return await response.value();
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplate3Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteApplicationTemplate3.');
        }
        if (requestParameters.applicationTemplateId === null || requestParameters.applicationTemplateId === undefined) {
            throw new runtime.RequiredError('applicationTemplateId', 'Required parameter requestParameters.applicationTemplateId was null or undefined when calling waypointServiceDeleteApplicationTemplate3.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateName !== undefined) {
            queryParameters['application_template.name'] = requestParameters.applicationTemplateName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/{application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.id"}}`, encodeURIComponent(String(requestParameters.applicationTemplateId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplate3(namespaceId, applicationTemplateId, applicationTemplateName) {
        const response = await this.waypointServiceDeleteApplicationTemplate3Raw({ namespaceId: namespaceId, applicationTemplateId: applicationTemplateId, applicationTemplateName: applicationTemplateName });
        return await response.value();
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplate4Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteApplicationTemplate4.');
        }
        if (requestParameters.applicationTemplateName === null || requestParameters.applicationTemplateName === undefined) {
            throw new runtime.RequiredError('applicationTemplateName', 'Required parameter requestParameters.applicationTemplateName was null or undefined when calling waypointServiceDeleteApplicationTemplate4.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateId !== undefined) {
            queryParameters['application_template.id'] = requestParameters.applicationTemplateId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/by-name/{application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.name"}}`, encodeURIComponent(String(requestParameters.applicationTemplateName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteApplicationTemplate deletes a application template by the application template name or id
     */
    async waypointServiceDeleteApplicationTemplate4(namespaceId, applicationTemplateName, applicationTemplateId) {
        const response = await this.waypointServiceDeleteApplicationTemplate4Raw({ namespaceId: namespaceId, applicationTemplateName: applicationTemplateName, applicationTemplateId: applicationTemplateId });
        return await response.value();
    }
    /**
     * DeleteNamespace deletes an HCP Waypoint namespace.
     */
    async waypointServiceDeleteNamespaceRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling waypointServiceDeleteNamespace.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling waypointServiceDeleteNamespace.');
        }
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteNamespace.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/organizations/{location.organization_id}/projects/{location.project_id}/namespaces/{namespace.id}`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))).replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteNamespace deletes an HCP Waypoint namespace.
     */
    async waypointServiceDeleteNamespace(locationOrganizationId, locationProjectId, namespaceId, locationRegionProvider, locationRegionRegion) {
        const response = await this.waypointServiceDeleteNamespaceRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, namespaceId: namespaceId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     * DeleteTFCConfig deletes a Terraform configuration
     */
    async waypointServiceDeleteTFCConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteTFCConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfcconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteTFCConfig deletes a Terraform configuration
     */
    async waypointServiceDeleteTFCConfig(namespaceId) {
        const response = await this.waypointServiceDeleteTFCConfigRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     */
    async waypointServiceDeleteVariableRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDeleteVariable.');
        }
        const queryParameters = {};
        if (requestParameters.variableId !== undefined) {
            queryParameters['variable.id'] = requestParameters.variableId;
        }
        if (requestParameters.variableKey !== undefined) {
            queryParameters['variable.key'] = requestParameters.variableKey;
        }
        if (requestParameters.variableActionId !== undefined) {
            queryParameters['variable.action.id'] = requestParameters.variableActionId;
        }
        if (requestParameters.variableActionName !== undefined) {
            queryParameters['variable.action.name'] = requestParameters.variableActionName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/variable`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async waypointServiceDeleteVariable(namespaceId, variableId, variableKey, variableActionId, variableActionName) {
        const response = await this.waypointServiceDeleteVariableRaw({ namespaceId: namespaceId, variableId: variableId, variableKey: variableKey, variableActionId: variableActionId, variableActionName: variableActionName });
        return await response.value();
    }
    /**
     * DestroyAddOn destroys an existing Add-on
     */
    async waypointServiceDestroyAddOnRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDestroyAddOn.');
        }
        if (requestParameters.addOnId === null || requestParameters.addOnId === undefined) {
            throw new runtime.RequiredError('addOnId', 'Required parameter requestParameters.addOnId was null or undefined when calling waypointServiceDestroyAddOn.');
        }
        const queryParameters = {};
        if (requestParameters.addOnName !== undefined) {
            queryParameters['add_on.name'] = requestParameters.addOnName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on/{add_on.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on.id"}}`, encodeURIComponent(String(requestParameters.addOnId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DestroyAddOn destroys an existing Add-on
     */
    async waypointServiceDestroyAddOn(namespaceId, addOnId, addOnName) {
        const response = await this.waypointServiceDestroyAddOnRaw({ namespaceId: namespaceId, addOnId: addOnId, addOnName: addOnName });
        return await response.value();
    }
    /**
     * DestroyAddOn destroys an existing Add-on
     */
    async waypointServiceDestroyAddOn2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDestroyAddOn2.');
        }
        if (requestParameters.addOnName === null || requestParameters.addOnName === undefined) {
            throw new runtime.RequiredError('addOnName', 'Required parameter requestParameters.addOnName was null or undefined when calling waypointServiceDestroyAddOn2.');
        }
        const queryParameters = {};
        if (requestParameters.addOnId !== undefined) {
            queryParameters['add_on.id'] = requestParameters.addOnId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on/by-name/{add_on.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on.name"}}`, encodeURIComponent(String(requestParameters.addOnName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DestroyAddOn destroys an existing Add-on
     */
    async waypointServiceDestroyAddOn2(namespaceId, addOnName, addOnId) {
        const response = await this.waypointServiceDestroyAddOn2Raw({ namespaceId: namespaceId, addOnName: addOnName, addOnId: addOnId });
        return await response.value();
    }
    /**
     * DestroyApplication destroys an existing application. A destroy operation is queued for the application\'s Terraform workspace, and the application is deleted from HCP Waypoint.
     */
    async waypointServiceDestroyApplicationRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDestroyApplication.');
        }
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId', 'Required parameter requestParameters.applicationId was null or undefined when calling waypointServiceDestroyApplication.');
        }
        const queryParameters = {};
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/{application.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.id"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DestroyApplication destroys an existing application. A destroy operation is queued for the application\'s Terraform workspace, and the application is deleted from HCP Waypoint.
     */
    async waypointServiceDestroyApplication(namespaceId, applicationId, applicationName) {
        const response = await this.waypointServiceDestroyApplicationRaw({ namespaceId: namespaceId, applicationId: applicationId, applicationName: applicationName });
        return await response.value();
    }
    /**
     * DestroyApplication destroys an existing application. A destroy operation is queued for the application\'s Terraform workspace, and the application is deleted from HCP Waypoint.
     */
    async waypointServiceDestroyApplication2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceDestroyApplication2.');
        }
        if (requestParameters.applicationName === null || requestParameters.applicationName === undefined) {
            throw new runtime.RequiredError('applicationName', 'Required parameter requestParameters.applicationName was null or undefined when calling waypointServiceDestroyApplication2.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/by-name/{application.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.name"}}`, encodeURIComponent(String(requestParameters.applicationName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DestroyApplication destroys an existing application. A destroy operation is queued for the application\'s Terraform workspace, and the application is deleted from HCP Waypoint.
     */
    async waypointServiceDestroyApplication2(namespaceId, applicationName, applicationId) {
        const response = await this.waypointServiceDestroyApplication2Raw({ namespaceId: namespaceId, applicationName: applicationName, applicationId: applicationId });
        return await response.value();
    }
    /**
     * EndingAction is run by the agent after it\'s operation finishes and it called StartingAction before running the operation. It includes the action run id that was retrieved from StartingAction. This also includes the ability to send a final status log message that will be included for the action run.
     */
    async waypointServiceEndingActionRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceEndingAction.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceEndingAction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/operation:endAction`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceEndingActionBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * EndingAction is run by the agent after it\'s operation finishes and it called StartingAction before running the operation. It includes the action run id that was retrieved from StartingAction. This also includes the ability to send a final status log message that will be included for the action run.
     */
    async waypointServiceEndingAction(namespaceId, body) {
        const response = await this.waypointServiceEndingActionRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * Config Endpoints
     */
    async waypointServiceGetActionConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetActionConfig.');
        }
        const queryParameters = {};
        if (requestParameters.actionId !== undefined) {
            queryParameters['action_id'] = requestParameters.actionId;
        }
        if (requestParameters.actionName !== undefined) {
            queryParameters['action_name'] = requestParameters.actionName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/actionconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetActionConfigResponseFromJSON(jsonValue));
    }
    /**
     * Config Endpoints
     */
    async waypointServiceGetActionConfig(namespaceId, actionId, actionName) {
        const response = await this.waypointServiceGetActionConfigRaw({ namespaceId: namespaceId, actionId: actionId, actionName: actionName });
        return await response.value();
    }
    /**
     */
    async waypointServiceGetActionRunRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetActionRun.');
        }
        const queryParameters = {};
        if (requestParameters.actionId !== undefined) {
            queryParameters['action_id'] = requestParameters.actionId;
        }
        if (requestParameters.actionName !== undefined) {
            queryParameters['action_name'] = requestParameters.actionName;
        }
        if (requestParameters.sequence !== undefined) {
            queryParameters['sequence'] = requestParameters.sequence;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/action`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetActionRunResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceGetActionRun(namespaceId, actionId, actionName, sequence) {
        const response = await this.waypointServiceGetActionRunRaw({ namespaceId: namespaceId, actionId: actionId, actionName: actionName, sequence: sequence });
        return await response.value();
    }
    /**
     * GetAddOn returns an existing Add-on
     */
    async waypointServiceGetAddOnRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetAddOn.');
        }
        if (requestParameters.addOnId === null || requestParameters.addOnId === undefined) {
            throw new runtime.RequiredError('addOnId', 'Required parameter requestParameters.addOnId was null or undefined when calling waypointServiceGetAddOn.');
        }
        const queryParameters = {};
        if (requestParameters.addOnName !== undefined) {
            queryParameters['add_on.name'] = requestParameters.addOnName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on/{add_on.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on.id"}}`, encodeURIComponent(String(requestParameters.addOnId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetAddOnResponseFromJSON(jsonValue));
    }
    /**
     * GetAddOn returns an existing Add-on
     */
    async waypointServiceGetAddOn(namespaceId, addOnId, addOnName) {
        const response = await this.waypointServiceGetAddOnRaw({ namespaceId: namespaceId, addOnId: addOnId, addOnName: addOnName });
        return await response.value();
    }
    /**
     * GetAddOn returns an existing Add-on
     */
    async waypointServiceGetAddOn2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetAddOn2.');
        }
        if (requestParameters.addOnName === null || requestParameters.addOnName === undefined) {
            throw new runtime.RequiredError('addOnName', 'Required parameter requestParameters.addOnName was null or undefined when calling waypointServiceGetAddOn2.');
        }
        const queryParameters = {};
        if (requestParameters.addOnId !== undefined) {
            queryParameters['add_on.id'] = requestParameters.addOnId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on/by-name/{add_on.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on.name"}}`, encodeURIComponent(String(requestParameters.addOnName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetAddOnResponseFromJSON(jsonValue));
    }
    /**
     * GetAddOn returns an existing Add-on
     */
    async waypointServiceGetAddOn2(namespaceId, addOnName, addOnId) {
        const response = await this.waypointServiceGetAddOn2Raw({ namespaceId: namespaceId, addOnName: addOnName, addOnId: addOnId });
        return await response.value();
    }
    /**
     * GetAddOnDefinition returns an Add-on definition, referenced by name or ID
     */
    async waypointServiceGetAddOnDefinitionRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetAddOnDefinition.');
        }
        if (requestParameters.addOnDefinitionId === null || requestParameters.addOnDefinitionId === undefined) {
            throw new runtime.RequiredError('addOnDefinitionId', 'Required parameter requestParameters.addOnDefinitionId was null or undefined when calling waypointServiceGetAddOnDefinition.');
        }
        const queryParameters = {};
        if (requestParameters.addOnDefinitionName !== undefined) {
            queryParameters['add_on_definition.name'] = requestParameters.addOnDefinitionName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definition/{add_on_definition.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on_definition.id"}}`, encodeURIComponent(String(requestParameters.addOnDefinitionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetAddOnDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * GetAddOnDefinition returns an Add-on definition, referenced by name or ID
     */
    async waypointServiceGetAddOnDefinition(namespaceId, addOnDefinitionId, addOnDefinitionName) {
        const response = await this.waypointServiceGetAddOnDefinitionRaw({ namespaceId: namespaceId, addOnDefinitionId: addOnDefinitionId, addOnDefinitionName: addOnDefinitionName });
        return await response.value();
    }
    /**
     * GetAddOnDefinition returns an Add-on definition, referenced by name or ID
     */
    async waypointServiceGetAddOnDefinition2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetAddOnDefinition2.');
        }
        if (requestParameters.addOnDefinitionName === null || requestParameters.addOnDefinitionName === undefined) {
            throw new runtime.RequiredError('addOnDefinitionName', 'Required parameter requestParameters.addOnDefinitionName was null or undefined when calling waypointServiceGetAddOnDefinition2.');
        }
        const queryParameters = {};
        if (requestParameters.addOnDefinitionId !== undefined) {
            queryParameters['add_on_definition.id'] = requestParameters.addOnDefinitionId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definition/by-name/{add_on_definition.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on_definition.name"}}`, encodeURIComponent(String(requestParameters.addOnDefinitionName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetAddOnDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * GetAddOnDefinition returns an Add-on definition, referenced by name or ID
     */
    async waypointServiceGetAddOnDefinition2(namespaceId, addOnDefinitionName, addOnDefinitionId) {
        const response = await this.waypointServiceGetAddOnDefinition2Raw({ namespaceId: namespaceId, addOnDefinitionName: addOnDefinitionName, addOnDefinitionId: addOnDefinitionId });
        return await response.value();
    }
    /**
     * GetAgentGroup returns the information about the specified group.
     */
    async waypointServiceGetAgentGroupRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetAgentGroup.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling waypointServiceGetAgentGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/group/{name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetAgentGroupResponseFromJSON(jsonValue));
    }
    /**
     * GetAgentGroup returns the information about the specified group.
     */
    async waypointServiceGetAgentGroup(namespaceId, name) {
        const response = await this.waypointServiceGetAgentGroupRaw({ namespaceId: namespaceId, name: name });
        return await response.value();
    }
    /**
     * GetApplication returns an application by ID or name.
     */
    async waypointServiceGetApplicationRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetApplication.');
        }
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId', 'Required parameter requestParameters.applicationId was null or undefined when calling waypointServiceGetApplication.');
        }
        const queryParameters = {};
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/{application.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.id"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetApplicationResponseFromJSON(jsonValue));
    }
    /**
     * GetApplication returns an application by ID or name.
     */
    async waypointServiceGetApplication(namespaceId, applicationId, applicationName) {
        const response = await this.waypointServiceGetApplicationRaw({ namespaceId: namespaceId, applicationId: applicationId, applicationName: applicationName });
        return await response.value();
    }
    /**
     * GetApplication returns an application by ID or name.
     */
    async waypointServiceGetApplication2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetApplication2.');
        }
        if (requestParameters.applicationName === null || requestParameters.applicationName === undefined) {
            throw new runtime.RequiredError('applicationName', 'Required parameter requestParameters.applicationName was null or undefined when calling waypointServiceGetApplication2.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/by-name/{application.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.name"}}`, encodeURIComponent(String(requestParameters.applicationName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetApplicationResponseFromJSON(jsonValue));
    }
    /**
     * GetApplication returns an application by ID or name.
     */
    async waypointServiceGetApplication2(namespaceId, applicationName, applicationId) {
        const response = await this.waypointServiceGetApplication2Raw({ namespaceId: namespaceId, applicationName: applicationName, applicationId: applicationId });
        return await response.value();
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplateRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetApplicationTemplate.');
        }
        if (requestParameters.applicationTemplateId === null || requestParameters.applicationTemplateId === undefined) {
            throw new runtime.RequiredError('applicationTemplateId', 'Required parameter requestParameters.applicationTemplateId was null or undefined when calling waypointServiceGetApplicationTemplate.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateName !== undefined) {
            queryParameters['application_template.name'] = requestParameters.applicationTemplateName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates/{application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.id"}}`, encodeURIComponent(String(requestParameters.applicationTemplateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplate(namespaceId, applicationTemplateId, applicationTemplateName) {
        const response = await this.waypointServiceGetApplicationTemplateRaw({ namespaceId: namespaceId, applicationTemplateId: applicationTemplateId, applicationTemplateName: applicationTemplateName });
        return await response.value();
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplate2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetApplicationTemplate2.');
        }
        if (requestParameters.applicationTemplateName === null || requestParameters.applicationTemplateName === undefined) {
            throw new runtime.RequiredError('applicationTemplateName', 'Required parameter requestParameters.applicationTemplateName was null or undefined when calling waypointServiceGetApplicationTemplate2.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateId !== undefined) {
            queryParameters['application_template.id'] = requestParameters.applicationTemplateId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates/by-name/{application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.name"}}`, encodeURIComponent(String(requestParameters.applicationTemplateName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplate2(namespaceId, applicationTemplateName, applicationTemplateId) {
        const response = await this.waypointServiceGetApplicationTemplate2Raw({ namespaceId: namespaceId, applicationTemplateName: applicationTemplateName, applicationTemplateId: applicationTemplateId });
        return await response.value();
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplate3Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetApplicationTemplate3.');
        }
        if (requestParameters.applicationTemplateId === null || requestParameters.applicationTemplateId === undefined) {
            throw new runtime.RequiredError('applicationTemplateId', 'Required parameter requestParameters.applicationTemplateId was null or undefined when calling waypointServiceGetApplicationTemplate3.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateName !== undefined) {
            queryParameters['application_template.name'] = requestParameters.applicationTemplateName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/{application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.id"}}`, encodeURIComponent(String(requestParameters.applicationTemplateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplate3(namespaceId, applicationTemplateId, applicationTemplateName) {
        const response = await this.waypointServiceGetApplicationTemplate3Raw({ namespaceId: namespaceId, applicationTemplateId: applicationTemplateId, applicationTemplateName: applicationTemplateName });
        return await response.value();
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplate4Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetApplicationTemplate4.');
        }
        if (requestParameters.applicationTemplateName === null || requestParameters.applicationTemplateName === undefined) {
            throw new runtime.RequiredError('applicationTemplateName', 'Required parameter requestParameters.applicationTemplateName was null or undefined when calling waypointServiceGetApplicationTemplate4.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateId !== undefined) {
            queryParameters['application_template.id'] = requestParameters.applicationTemplateId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/by-name/{application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.name"}}`, encodeURIComponent(String(requestParameters.applicationTemplateName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * GetApplicationTemplate returns a application template by the application template name or id
     */
    async waypointServiceGetApplicationTemplate4(namespaceId, applicationTemplateName, applicationTemplateId) {
        const response = await this.waypointServiceGetApplicationTemplate4Raw({ namespaceId: namespaceId, applicationTemplateName: applicationTemplateName, applicationTemplateId: applicationTemplateId });
        return await response.value();
    }
    /**
     * GetNamespace gets a namespace, based on either the namespace ID or an HCP location. Returns NotFound if the namespace doesn\'t exist.
     */
    async waypointServiceGetNamespaceRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling waypointServiceGetNamespace.');
        }
        if (requestParameters.locationProjectId === null || requestParameters.locationProjectId === undefined) {
            throw new runtime.RequiredError('locationProjectId', 'Required parameter requestParameters.locationProjectId was null or undefined when calling waypointServiceGetNamespace.');
        }
        const queryParameters = {};
        if (requestParameters.locationRegionProvider !== undefined) {
            queryParameters['location.region.provider'] = requestParameters.locationRegionProvider;
        }
        if (requestParameters.locationRegionRegion !== undefined) {
            queryParameters['location.region.region'] = requestParameters.locationRegionRegion;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/organizations/{location.organization_id}/projects/{location.project_id}/namespaces`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))).replace(`{${"location.project_id"}}`, encodeURIComponent(String(requestParameters.locationProjectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetNamespaceResponseFromJSON(jsonValue));
    }
    /**
     * GetNamespace gets a namespace, based on either the namespace ID or an HCP location. Returns NotFound if the namespace doesn\'t exist.
     */
    async waypointServiceGetNamespace(locationOrganizationId, locationProjectId, locationRegionProvider, locationRegionRegion) {
        const response = await this.waypointServiceGetNamespaceRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, locationRegionProvider: locationRegionProvider, locationRegionRegion: locationRegionRegion });
        return await response.value();
    }
    /**
     * GetTFCConfig gets the server-stored Terraform Cloud config
     */
    async waypointServiceGetTFCConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFCConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfcconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFCConfigResponseFromJSON(jsonValue));
    }
    /**
     * GetTFCConfig gets the server-stored Terraform Cloud config
     */
    async waypointServiceGetTFCConfig(namespaceId) {
        const response = await this.waypointServiceGetTFCConfigRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     * GetTFModuleDetails returns the details of a specific no-code module.
     */
    async waypointServiceGetTFModuleDetailsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFModuleDetails.');
        }
        if (requestParameters.tfcNamespace === null || requestParameters.tfcNamespace === undefined) {
            throw new runtime.RequiredError('tfcNamespace', 'Required parameter requestParameters.tfcNamespace was null or undefined when calling waypointServiceGetTFModuleDetails.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling waypointServiceGetTFModuleDetails.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling waypointServiceGetTFModuleDetails.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling waypointServiceGetTFModuleDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tf-module-details/{tfc_namespace}/{name}/{provider}/{version}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"tfc_namespace"}}`, encodeURIComponent(String(requestParameters.tfcNamespace))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFModuleDetailsResponseFromJSON(jsonValue));
    }
    /**
     * GetTFModuleDetails returns the details of a specific no-code module.
     */
    async waypointServiceGetTFModuleDetails(namespaceId, tfcNamespace, name, provider, version) {
        const response = await this.waypointServiceGetTFModuleDetailsRaw({ namespaceId: namespaceId, tfcNamespace: tfcNamespace, name: name, provider: provider, version: version });
        return await response.value();
    }
    /**
     * GetTFModuleDetails returns the details of a specific no-code module.
     */
    async waypointServiceGetTFModuleDetails2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFModuleDetails2.');
        }
        if (requestParameters.tfcNamespace === null || requestParameters.tfcNamespace === undefined) {
            throw new runtime.RequiredError('tfcNamespace', 'Required parameter requestParameters.tfcNamespace was null or undefined when calling waypointServiceGetTFModuleDetails2.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling waypointServiceGetTFModuleDetails2.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling waypointServiceGetTFModuleDetails2.');
        }
        const queryParameters = {};
        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tf-module-details/{tfc_namespace}/{name}/{provider}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"tfc_namespace"}}`, encodeURIComponent(String(requestParameters.tfcNamespace))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFModuleDetailsResponseFromJSON(jsonValue));
    }
    /**
     * GetTFModuleDetails returns the details of a specific no-code module.
     */
    async waypointServiceGetTFModuleDetails2(namespaceId, tfcNamespace, name, provider, version) {
        const response = await this.waypointServiceGetTFModuleDetails2Raw({ namespaceId: namespaceId, tfcNamespace: tfcNamespace, name: name, provider: provider, version: version });
        return await response.value();
    }
    /**
     * GetTFRunStatus returns the status of the latest run of a Terraform workspace
     */
    async waypointServiceGetTFRunStatusRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFRunStatus.');
        }
        if (requestParameters.workspaceName === null || requestParameters.workspaceName === undefined) {
            throw new runtime.RequiredError('workspaceName', 'Required parameter requestParameters.workspaceName was null or undefined when calling waypointServiceGetTFRunStatus.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tf-run-status/{workspace_name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"workspace_name"}}`, encodeURIComponent(String(requestParameters.workspaceName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFRunStatusResponseFromJSON(jsonValue));
    }
    /**
     * GetTFRunStatus returns the status of the latest run of a Terraform workspace
     */
    async waypointServiceGetTFRunStatus(namespaceId, workspaceName) {
        const response = await this.waypointServiceGetTFRunStatusRaw({ namespaceId: namespaceId, workspaceName: workspaceName });
        return await response.value();
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfoRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFWorkspaceInfo.');
        }
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId', 'Required parameter requestParameters.applicationId was null or undefined when calling waypointServiceGetTFWorkspaceInfo.');
        }
        const queryParameters = {};
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        if (requestParameters.addOnId !== undefined) {
            queryParameters['add_on.id'] = requestParameters.addOnId;
        }
        if (requestParameters.addOnName !== undefined) {
            queryParameters['add_on.name'] = requestParameters.addOnName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application/{application.id}/workspace`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.id"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFWorkspaceInfoResponseFromJSON(jsonValue));
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfo(namespaceId, applicationId, applicationName, addOnId, addOnName) {
        const response = await this.waypointServiceGetTFWorkspaceInfoRaw({ namespaceId: namespaceId, applicationId: applicationId, applicationName: applicationName, addOnId: addOnId, addOnName: addOnName });
        return await response.value();
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfo2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFWorkspaceInfo2.');
        }
        if (requestParameters.applicationName === null || requestParameters.applicationName === undefined) {
            throw new runtime.RequiredError('applicationName', 'Required parameter requestParameters.applicationName was null or undefined when calling waypointServiceGetTFWorkspaceInfo2.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        if (requestParameters.addOnId !== undefined) {
            queryParameters['add_on.id'] = requestParameters.addOnId;
        }
        if (requestParameters.addOnName !== undefined) {
            queryParameters['add_on.name'] = requestParameters.addOnName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application/by-name/{application.name}/workspace`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.name"}}`, encodeURIComponent(String(requestParameters.applicationName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFWorkspaceInfoResponseFromJSON(jsonValue));
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfo2(namespaceId, applicationName, applicationId, addOnId, addOnName) {
        const response = await this.waypointServiceGetTFWorkspaceInfo2Raw({ namespaceId: namespaceId, applicationName: applicationName, applicationId: applicationId, addOnId: addOnId, addOnName: addOnName });
        return await response.value();
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfo3Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFWorkspaceInfo3.');
        }
        if (requestParameters.addOnName === null || requestParameters.addOnName === undefined) {
            throw new runtime.RequiredError('addOnName', 'Required parameter requestParameters.addOnName was null or undefined when calling waypointServiceGetTFWorkspaceInfo3.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        if (requestParameters.addOnId !== undefined) {
            queryParameters['add_on.id'] = requestParameters.addOnId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on/by-name/{add_on.name}/workspace`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on.name"}}`, encodeURIComponent(String(requestParameters.addOnName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFWorkspaceInfoResponseFromJSON(jsonValue));
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfo3(namespaceId, addOnName, applicationId, applicationName, addOnId) {
        const response = await this.waypointServiceGetTFWorkspaceInfo3Raw({ namespaceId: namespaceId, addOnName: addOnName, applicationId: applicationId, applicationName: applicationName, addOnId: addOnId });
        return await response.value();
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfo4Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetTFWorkspaceInfo4.');
        }
        if (requestParameters.addOnId === null || requestParameters.addOnId === undefined) {
            throw new runtime.RequiredError('addOnId', 'Required parameter requestParameters.addOnId was null or undefined when calling waypointServiceGetTFWorkspaceInfo4.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        if (requestParameters.addOnName !== undefined) {
            queryParameters['add_on.name'] = requestParameters.addOnName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on/{add_on.id}/workspace`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"add_on.id"}}`, encodeURIComponent(String(requestParameters.addOnId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetTFWorkspaceInfoResponseFromJSON(jsonValue));
    }
    /**
     * Used to retrieve the upgrade status of a workspace given the workspace id or workspace name.
     */
    async waypointServiceGetTFWorkspaceInfo4(namespaceId, addOnId, applicationId, applicationName, addOnName) {
        const response = await this.waypointServiceGetTFWorkspaceInfo4Raw({ namespaceId: namespaceId, addOnId: addOnId, applicationId: applicationId, applicationName: applicationName, addOnName: addOnName });
        return await response.value();
    }
    /**
     */
    async waypointServiceGetVariableRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceGetVariable.');
        }
        const queryParameters = {};
        if (requestParameters.variableId !== undefined) {
            queryParameters['variable.id'] = requestParameters.variableId;
        }
        if (requestParameters.variableKey !== undefined) {
            queryParameters['variable.key'] = requestParameters.variableKey;
        }
        if (requestParameters.variableActionId !== undefined) {
            queryParameters['variable.action.id'] = requestParameters.variableActionId;
        }
        if (requestParameters.variableActionName !== undefined) {
            queryParameters['variable.action.name'] = requestParameters.variableActionName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/variable`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointGetVariableResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceGetVariable(namespaceId, variableId, variableKey, variableActionId, variableActionName) {
        const response = await this.waypointServiceGetVariableRaw({ namespaceId: namespaceId, variableId: variableId, variableKey: variableKey, variableActionId: variableActionId, variableActionName: variableActionName });
        return await response.value();
    }
    /**
     */
    async waypointServiceListActionConfigsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListActionConfigs.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/actionconfigs`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListActionConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceListActionConfigs(namespaceId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.waypointServiceListActionConfigsRaw({ namespaceId: namespaceId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * Lists all action runs for a given config
     */
    async waypointServiceListActionRunsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListActionRuns.');
        }
        if (requestParameters.actionId === null || requestParameters.actionId === undefined) {
            throw new runtime.RequiredError('actionId', 'Required parameter requestParameters.actionId was null or undefined when calling waypointServiceListActionRuns.');
        }
        const queryParameters = {};
        if (requestParameters.actionName !== undefined) {
            queryParameters['action_name'] = requestParameters.actionName;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.scopeApplicationId !== undefined) {
            queryParameters['scope.application.id'] = requestParameters.scopeApplicationId;
        }
        if (requestParameters.scopeApplicationName !== undefined) {
            queryParameters['scope.application.name'] = requestParameters.scopeApplicationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/action/{action_id}/runs`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"action_id"}}`, encodeURIComponent(String(requestParameters.actionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListActionRunsResponseFromJSON(jsonValue));
    }
    /**
     * Lists all action runs for a given config
     */
    async waypointServiceListActionRuns(namespaceId, actionId, actionName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, scopeApplicationId, scopeApplicationName) {
        const response = await this.waypointServiceListActionRunsRaw({ namespaceId: namespaceId, actionId: actionId, actionName: actionName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, scopeApplicationId: scopeApplicationId, scopeApplicationName: scopeApplicationName });
        return await response.value();
    }
    /**
     * Lists all action runs for a given config
     */
    async waypointServiceListActionRuns2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListActionRuns2.');
        }
        if (requestParameters.actionName === null || requestParameters.actionName === undefined) {
            throw new runtime.RequiredError('actionName', 'Required parameter requestParameters.actionName was null or undefined when calling waypointServiceListActionRuns2.');
        }
        const queryParameters = {};
        if (requestParameters.actionId !== undefined) {
            queryParameters['action_id'] = requestParameters.actionId;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.scopeApplicationId !== undefined) {
            queryParameters['scope.application.id'] = requestParameters.scopeApplicationId;
        }
        if (requestParameters.scopeApplicationName !== undefined) {
            queryParameters['scope.application.name'] = requestParameters.scopeApplicationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/action/by-name/{action_name}/runs`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"action_name"}}`, encodeURIComponent(String(requestParameters.actionName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListActionRunsResponseFromJSON(jsonValue));
    }
    /**
     * Lists all action runs for a given config
     */
    async waypointServiceListActionRuns2(namespaceId, actionName, actionId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, scopeApplicationId, scopeApplicationName) {
        const response = await this.waypointServiceListActionRuns2Raw({ namespaceId: namespaceId, actionName: actionName, actionId: actionId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, scopeApplicationId: scopeApplicationId, scopeApplicationName: scopeApplicationName });
        return await response.value();
    }
    /**
     * Lists all action runs for the entire namespace, for all configs
     */
    async waypointServiceListActionRunsByNamespaceRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListActionRunsByNamespace.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.scopeApplicationId !== undefined) {
            queryParameters['scope.application.id'] = requestParameters.scopeApplicationId;
        }
        if (requestParameters.scopeApplicationName !== undefined) {
            queryParameters['scope.application.name'] = requestParameters.scopeApplicationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/action-runs`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListActionRunsByNamespaceResponseFromJSON(jsonValue));
    }
    /**
     * Lists all action runs for the entire namespace, for all configs
     */
    async waypointServiceListActionRunsByNamespace(namespaceId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, scopeApplicationId, scopeApplicationName) {
        const response = await this.waypointServiceListActionRunsByNamespaceRaw({ namespaceId: namespaceId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, scopeApplicationId: scopeApplicationId, scopeApplicationName: scopeApplicationName });
        return await response.value();
    }
    /**
     * ListAddOnDefinitions returns all existing Add-on definitions
     */
    async waypointServiceListAddOnDefinitionsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListAddOnDefinitions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.withTotalCount !== undefined) {
            queryParameters['with_total_count'] = requestParameters.withTotalCount;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definitions`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListAddOnDefinitionsResponseFromJSON(jsonValue));
    }
    /**
     * ListAddOnDefinitions returns all existing Add-on definitions
     */
    async waypointServiceListAddOnDefinitions(namespaceId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, withTotalCount) {
        const response = await this.waypointServiceListAddOnDefinitionsRaw({ namespaceId: namespaceId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, withTotalCount: withTotalCount });
        return await response.value();
    }
    /**
     * ListAddOns returns all existing Add-ons
     */
    async waypointServiceListAddOnsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListAddOns.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.withTotalCount !== undefined) {
            queryParameters['with_total_count'] = requestParameters.withTotalCount;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-ons`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListAddOnsResponseFromJSON(jsonValue));
    }
    /**
     * ListAddOns returns all existing Add-ons
     */
    async waypointServiceListAddOns(namespaceId, applicationId, applicationName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, withTotalCount) {
        const response = await this.waypointServiceListAddOnsRaw({ namespaceId: namespaceId, applicationId: applicationId, applicationName: applicationName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, withTotalCount: withTotalCount });
        return await response.value();
    }
    /**
     * ListAgentGroups returns the Agent groups defined on the HCP Project.
     */
    async waypointServiceListAgentGroupsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListAgentGroups.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/group`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListAgentGroupsResponseFromJSON(jsonValue));
    }
    /**
     * ListAgentGroups returns the Agent groups defined on the HCP Project.
     */
    async waypointServiceListAgentGroups(namespaceId) {
        const response = await this.waypointServiceListAgentGroupsRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     * ListApplicationTemplates returns a list of all application templates known.
     */
    async waypointServiceListApplicationTemplatesRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListApplicationTemplates.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.withTotalCount !== undefined) {
            queryParameters['with_total_count'] = requestParameters.withTotalCount;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListApplicationTemplatesResponseFromJSON(jsonValue));
    }
    /**
     * ListApplicationTemplates returns a list of all application templates known.
     */
    async waypointServiceListApplicationTemplates(namespaceId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, withTotalCount) {
        const response = await this.waypointServiceListApplicationTemplatesRaw({ namespaceId: namespaceId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, withTotalCount: withTotalCount });
        return await response.value();
    }
    /**
     * ListApplicationTemplates returns a list of all application templates known.
     */
    async waypointServiceListApplicationTemplates2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListApplicationTemplates2.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.withTotalCount !== undefined) {
            queryParameters['with_total_count'] = requestParameters.withTotalCount;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListApplicationTemplatesResponseFromJSON(jsonValue));
    }
    /**
     * ListApplicationTemplates returns a list of all application templates known.
     */
    async waypointServiceListApplicationTemplates2(namespaceId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, withTotalCount) {
        const response = await this.waypointServiceListApplicationTemplates2Raw({ namespaceId: namespaceId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, withTotalCount: withTotalCount });
        return await response.value();
    }
    /**
     * ListApplications returns a list of all applications.
     */
    async waypointServiceListApplicationsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListApplications.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.withTotalCount !== undefined) {
            queryParameters['with_total_count'] = requestParameters.withTotalCount;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListApplicationsResponseFromJSON(jsonValue));
    }
    /**
     * ListApplications returns a list of all applications.
     */
    async waypointServiceListApplications(namespaceId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, withTotalCount) {
        const response = await this.waypointServiceListApplicationsRaw({ namespaceId: namespaceId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, withTotalCount: withTotalCount });
        return await response.value();
    }
    /**
     * ListNoCodeModules returns a list of available no-code module for the configured TFC organization.
     */
    async waypointServiceListNoCodeModulesRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListNoCodeModules.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfcmodules`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListNoCodeModulesResponseFromJSON(jsonValue));
    }
    /**
     * ListNoCodeModules returns a list of available no-code module for the configured TFC organization.
     */
    async waypointServiceListNoCodeModules(namespaceId) {
        const response = await this.waypointServiceListNoCodeModulesRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     * ListTFAgentPools returns a list of HCP Terraform agent pools
     */
    async waypointServiceListTFAgentPoolsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListTFAgentPools.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tf-agent-pools`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListTFAgentPoolsResponseFromJSON(jsonValue));
    }
    /**
     * ListTFAgentPools returns a list of HCP Terraform agent pools
     */
    async waypointServiceListTFAgentPools(namespaceId) {
        const response = await this.waypointServiceListTFAgentPoolsRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     * ListTFCOrganizations returns a list of available HCP Terraform organizations which can be used by the currently set token.
     */
    async waypointServiceListTFCOrganizationsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListTFCOrganizations.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceListTFCOrganizations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfc-organizations`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceListTFCOrganizationsBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListTFCOrganizationsResponseFromJSON(jsonValue));
    }
    /**
     * ListTFCOrganizations returns a list of available HCP Terraform organizations which can be used by the currently set token.
     */
    async waypointServiceListTFCOrganizations(namespaceId, body) {
        const response = await this.waypointServiceListTFCOrganizationsRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * ListTFCProjects returns a list of available TFC projects for the configured TFC organization.
     */
    async waypointServiceListTFCProjectsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListTFCProjects.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfc-projects`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListTerraformCloudProjectsResponseFromJSON(jsonValue));
    }
    /**
     * ListTFCProjects returns a list of available TFC projects for the configured TFC organization.
     */
    async waypointServiceListTFCProjects(namespaceId) {
        const response = await this.waypointServiceListTFCProjectsRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     */
    async waypointServiceListVariablesRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceListVariables.');
        }
        const queryParameters = {};
        if (requestParameters.scopeApplicationTemplateId !== undefined) {
            queryParameters['scope.application_template.id'] = requestParameters.scopeApplicationTemplateId;
        }
        if (requestParameters.scopeApplicationTemplateName !== undefined) {
            queryParameters['scope.application_template.name'] = requestParameters.scopeApplicationTemplateName;
        }
        if (requestParameters.scopeApplicationId !== undefined) {
            queryParameters['scope.application.id'] = requestParameters.scopeApplicationId;
        }
        if (requestParameters.scopeApplicationName !== undefined) {
            queryParameters['scope.application.name'] = requestParameters.scopeApplicationName;
        }
        if (requestParameters.scopeActionId !== undefined) {
            queryParameters['scope.action.id'] = requestParameters.scopeActionId;
        }
        if (requestParameters.scopeActionName !== undefined) {
            queryParameters['scope.action.name'] = requestParameters.scopeActionName;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/variables`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointListVariablesResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceListVariables(namespaceId, scopeApplicationTemplateId, scopeApplicationTemplateName, scopeApplicationId, scopeApplicationName, scopeActionId, scopeActionName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.waypointServiceListVariablesRaw({ namespaceId: namespaceId, scopeApplicationTemplateId: scopeApplicationTemplateId, scopeApplicationTemplateName: scopeApplicationTemplateName, scopeApplicationId: scopeApplicationId, scopeApplicationName: scopeApplicationName, scopeActionId: scopeActionId, scopeActionName: scopeActionName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * Used by any code that wishes to have an agent execute an operation, this places a new operation into the queue for a specific group. A future caller of RetrieveAgentOperation will then return that operation.
     */
    async waypointServiceQueueAgentOperationRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceQueueAgentOperation.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceQueueAgentOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/operation:queue`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceQueueAgentOperationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Used by any code that wishes to have an agent execute an operation, this places a new operation into the queue for a specific group. A future caller of RetrieveAgentOperation will then return that operation.
     */
    async waypointServiceQueueAgentOperation(namespaceId, body) {
        const response = await this.waypointServiceQueueAgentOperationRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * Used by the Agent itself, RetrieveAgentOperation returns any available operations from the specified groups. The Agent polls on this endpoint every 60 seconds by default.
     */
    async waypointServiceRetrieveAgentOperationRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceRetrieveAgentOperation.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceRetrieveAgentOperation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/operation:retrieve`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceRetrieveAgentOperationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointRetrieveAgentOperationResponseFromJSON(jsonValue));
    }
    /**
     * Used by the Agent itself, RetrieveAgentOperation returns any available operations from the specified groups. The Agent polls on this endpoint every 60 seconds by default.
     */
    async waypointServiceRetrieveAgentOperation(namespaceId, body) {
        const response = await this.waypointServiceRetrieveAgentOperationRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * Running Actions
     */
    async waypointServiceRunActionRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceRunAction.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceRunAction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/action`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceRunActionBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointRunActionResponseFromJSON(jsonValue));
    }
    /**
     * Running Actions
     */
    async waypointServiceRunAction(namespaceId, body) {
        const response = await this.waypointServiceRunActionRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * Status Logs for Action runs
     */
    async waypointServiceSendStatusLogRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceSendStatusLog.');
        }
        if (requestParameters.actionConfigId === null || requestParameters.actionConfigId === undefined) {
            throw new runtime.RequiredError('actionConfigId', 'Required parameter requestParameters.actionConfigId was null or undefined when calling waypointServiceSendStatusLog.');
        }
        if (requestParameters.actionRunSeq === null || requestParameters.actionRunSeq === undefined) {
            throw new runtime.RequiredError('actionRunSeq', 'Required parameter requestParameters.actionRunSeq was null or undefined when calling waypointServiceSendStatusLog.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceSendStatusLog.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/action/{action_config.id}/action-runs/{action_run_seq}/status-log`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"action_config.id"}}`, encodeURIComponent(String(requestParameters.actionConfigId))).replace(`{${"action_run_seq"}}`, encodeURIComponent(String(requestParameters.actionRunSeq))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceSendStatusLogBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Status Logs for Action runs
     */
    async waypointServiceSendStatusLog(namespaceId, actionConfigId, actionRunSeq, body) {
        const response = await this.waypointServiceSendStatusLogRaw({ namespaceId: namespaceId, actionConfigId: actionConfigId, actionRunSeq: actionRunSeq, body: body });
        return await response.value();
    }
    /**
     * StartingAction is run by the agent after retrieving an operation and seeing an action_config_id specified on the operation. This allows for agents to integrate with actions closely.
     */
    async waypointServiceStartingActionRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceStartingAction.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceStartingAction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/operation:startAction`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceStartingActionBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointStartingActionResponseFromJSON(jsonValue));
    }
    /**
     * StartingAction is run by the agent after retrieving an operation and seeing an action_config_id specified on the operation. This allows for agents to integrate with actions closely.
     */
    async waypointServiceStartingAction(namespaceId, body) {
        const response = await this.waypointServiceStartingActionRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     */
    async waypointServiceUIBulkUpdateActionAssignForAppRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIBulkUpdateActionAssignForApp.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUIBulkUpdateActionAssignForApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/applications/action-assignments`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUIBulkUpdateActionAssignForAppBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIBulkUpdateActionAssignmentsForAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceUIBulkUpdateActionAssignForApp(namespaceId, body) {
        const response = await this.waypointServiceUIBulkUpdateActionAssignForAppRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     */
    async waypointServiceUICreateActionConfigWithVarsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUICreateActionConfigWithVars.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUICreateActionConfigWithVars.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/actionconfigwithvars`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUICreateActionConfigWithVarsBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUICreateActionConfigWithVarsResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceUICreateActionConfigWithVars(namespaceId, body) {
        const response = await this.waypointServiceUICreateActionConfigWithVarsRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     */
    async waypointServiceUIGetActionConfigBundleRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIGetActionConfigBundle.');
        }
        if (requestParameters.actionId === null || requestParameters.actionId === undefined) {
            throw new runtime.RequiredError('actionId', 'Required parameter requestParameters.actionId was null or undefined when calling waypointServiceUIGetActionConfigBundle.');
        }
        const queryParameters = {};
        if (requestParameters.actionName !== undefined) {
            queryParameters['action_name'] = requestParameters.actionName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/actionconfig/{action_id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"action_id"}}`, encodeURIComponent(String(requestParameters.actionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIGetActionConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceUIGetActionConfigBundle(namespaceId, actionId, actionName) {
        const response = await this.waypointServiceUIGetActionConfigBundleRaw({ namespaceId: namespaceId, actionId: actionId, actionName: actionName });
        return await response.value();
    }
    /**
     */
    async waypointServiceUIGetActionConfigBundle2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIGetActionConfigBundle2.');
        }
        if (requestParameters.actionName === null || requestParameters.actionName === undefined) {
            throw new runtime.RequiredError('actionName', 'Required parameter requestParameters.actionName was null or undefined when calling waypointServiceUIGetActionConfigBundle2.');
        }
        const queryParameters = {};
        if (requestParameters.actionId !== undefined) {
            queryParameters['action_id'] = requestParameters.actionId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/actionconfig/by-name/{action_name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"action_name"}}`, encodeURIComponent(String(requestParameters.actionName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIGetActionConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceUIGetActionConfigBundle2(namespaceId, actionName, actionId) {
        const response = await this.waypointServiceUIGetActionConfigBundle2Raw({ namespaceId: namespaceId, actionName: actionName, actionId: actionId });
        return await response.value();
    }
    /**
     * UI_GetApplicationBundle returns an Application and any associated Action Configs it may have.
     */
    async waypointServiceUIGetApplicationBundleRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIGetApplicationBundle.');
        }
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId', 'Required parameter requestParameters.applicationId was null or undefined when calling waypointServiceUIGetApplicationBundle.');
        }
        const queryParameters = {};
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/applications/{application.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.id"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIGetApplicationBundleResponseFromJSON(jsonValue));
    }
    /**
     * UI_GetApplicationBundle returns an Application and any associated Action Configs it may have.
     */
    async waypointServiceUIGetApplicationBundle(namespaceId, applicationId, applicationName) {
        const response = await this.waypointServiceUIGetApplicationBundleRaw({ namespaceId: namespaceId, applicationId: applicationId, applicationName: applicationName });
        return await response.value();
    }
    /**
     * UI_GetApplicationBundle returns an Application and any associated Action Configs it may have.
     */
    async waypointServiceUIGetApplicationBundle2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIGetApplicationBundle2.');
        }
        if (requestParameters.applicationName === null || requestParameters.applicationName === undefined) {
            throw new runtime.RequiredError('applicationName', 'Required parameter requestParameters.applicationName was null or undefined when calling waypointServiceUIGetApplicationBundle2.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/applications/by-name/{application.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.name"}}`, encodeURIComponent(String(requestParameters.applicationName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIGetApplicationBundleResponseFromJSON(jsonValue));
    }
    /**
     * UI_GetApplicationBundle returns an Application and any associated Action Configs it may have.
     */
    async waypointServiceUIGetApplicationBundle2(namespaceId, applicationName, applicationId) {
        const response = await this.waypointServiceUIGetApplicationBundle2Raw({ namespaceId: namespaceId, applicationName: applicationName, applicationId: applicationId });
        return await response.value();
    }
    /**
     * UI_GetApplicationTemplateBundle returns a template, using a name or id to look it up. This RPC is used by the HCP Waypoint UI.
     */
    async waypointServiceUIGetApplicationTemplateBundleRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIGetApplicationTemplateBundle.');
        }
        if (requestParameters.applicationTemplateId === null || requestParameters.applicationTemplateId === undefined) {
            throw new runtime.RequiredError('applicationTemplateId', 'Required parameter requestParameters.applicationTemplateId was null or undefined when calling waypointServiceUIGetApplicationTemplateBundle.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateName !== undefined) {
            queryParameters['application_template.name'] = requestParameters.applicationTemplateName;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/application-templates/{application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.id"}}`, encodeURIComponent(String(requestParameters.applicationTemplateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIGetApplicationTemplateBundleResponseFromJSON(jsonValue));
    }
    /**
     * UI_GetApplicationTemplateBundle returns a template, using a name or id to look it up. This RPC is used by the HCP Waypoint UI.
     */
    async waypointServiceUIGetApplicationTemplateBundle(namespaceId, applicationTemplateId, applicationTemplateName) {
        const response = await this.waypointServiceUIGetApplicationTemplateBundleRaw({ namespaceId: namespaceId, applicationTemplateId: applicationTemplateId, applicationTemplateName: applicationTemplateName });
        return await response.value();
    }
    /**
     * UI_GetApplicationTemplateBundle returns a template, using a name or id to look it up. This RPC is used by the HCP Waypoint UI.
     */
    async waypointServiceUIGetApplicationTemplateBundle2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIGetApplicationTemplateBundle2.');
        }
        if (requestParameters.applicationTemplateName === null || requestParameters.applicationTemplateName === undefined) {
            throw new runtime.RequiredError('applicationTemplateName', 'Required parameter requestParameters.applicationTemplateName was null or undefined when calling waypointServiceUIGetApplicationTemplateBundle2.');
        }
        const queryParameters = {};
        if (requestParameters.applicationTemplateId !== undefined) {
            queryParameters['application_template.id'] = requestParameters.applicationTemplateId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/application-templates/by-name/{application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application_template.name"}}`, encodeURIComponent(String(requestParameters.applicationTemplateName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIGetApplicationTemplateBundleResponseFromJSON(jsonValue));
    }
    /**
     * UI_GetApplicationTemplateBundle returns a template, using a name or id to look it up. This RPC is used by the HCP Waypoint UI.
     */
    async waypointServiceUIGetApplicationTemplateBundle2(namespaceId, applicationTemplateName, applicationTemplateId) {
        const response = await this.waypointServiceUIGetApplicationTemplateBundle2Raw({ namespaceId: namespaceId, applicationTemplateName: applicationTemplateName, applicationTemplateId: applicationTemplateId });
        return await response.value();
    }
    /**
     */
    async waypointServiceUIListActionConfigBundlesRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIListActionConfigBundles.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/actionconfigs`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIListActionConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceUIListActionConfigBundles(namespaceId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.waypointServiceUIListActionConfigBundlesRaw({ namespaceId: namespaceId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * List AddOnDefinitions within the context of a project.
     */
    async waypointServiceUIListAddOnDefinitionsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUIListAddOnDefinitions.');
        }
        const queryParameters = {};
        if (requestParameters.applicationId !== undefined) {
            queryParameters['application.id'] = requestParameters.applicationId;
        }
        if (requestParameters.applicationName !== undefined) {
            queryParameters['application.name'] = requestParameters.applicationName;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/add-on-definitions`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUIListAddOnDefinitionsResponseFromJSON(jsonValue));
    }
    /**
     * List AddOnDefinitions within the context of a project.
     */
    async waypointServiceUIListAddOnDefinitions(namespaceId, applicationId, applicationName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.waypointServiceUIListAddOnDefinitionsRaw({ namespaceId: namespaceId, applicationId: applicationId, applicationName: applicationName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * UI_LoadProductBanner will call two functions for checking the stored TFC tokens expiration against TFC as well as the stored TFC orgs permisions as set by TFC. The UI uses this function to show product activation or deactivation banners.
     */
    async waypointServiceUILoadProductBannerRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUILoadProductBanner.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/ui/product-banner`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUILoadProductBannerResponseFromJSON(jsonValue));
    }
    /**
     * UI_LoadProductBanner will call two functions for checking the stored TFC tokens expiration against TFC as well as the stored TFC orgs permisions as set by TFC. The UI uses this function to show product activation or deactivation banners.
     */
    async waypointServiceUILoadProductBanner(namespaceId) {
        const response = await this.waypointServiceUILoadProductBannerRaw({ namespaceId: namespaceId });
        return await response.value();
    }
    /**
     */
    async waypointServiceUpdateActionConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateActionConfig.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateActionConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/actionconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateActionConfigBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateActionConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceUpdateActionConfig(namespaceId, body) {
        const response = await this.waypointServiceUpdateActionConfigRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * UpdateAddOn updates an existing Add-on
     */
    async waypointServiceUpdateAddOnRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateAddOn.');
        }
        if (requestParameters.existingAddOnId === null || requestParameters.existingAddOnId === undefined) {
            throw new runtime.RequiredError('existingAddOnId', 'Required parameter requestParameters.existingAddOnId was null or undefined when calling waypointServiceUpdateAddOn.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateAddOn.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on/{existing_add_on.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_add_on.id"}}`, encodeURIComponent(String(requestParameters.existingAddOnId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateAddOnBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateAddOnResponseFromJSON(jsonValue));
    }
    /**
     * UpdateAddOn updates an existing Add-on
     */
    async waypointServiceUpdateAddOn(namespaceId, existingAddOnId, body) {
        const response = await this.waypointServiceUpdateAddOnRaw({ namespaceId: namespaceId, existingAddOnId: existingAddOnId, body: body });
        return await response.value();
    }
    /**
     * UpdateAddOnDefinition updates an existing Add-on definition
     */
    async waypointServiceUpdateAddOnDefinitionRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateAddOnDefinition.');
        }
        if (requestParameters.existingAddOnDefinitionId === null || requestParameters.existingAddOnDefinitionId === undefined) {
            throw new runtime.RequiredError('existingAddOnDefinitionId', 'Required parameter requestParameters.existingAddOnDefinitionId was null or undefined when calling waypointServiceUpdateAddOnDefinition.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateAddOnDefinition.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definition/{existing_add_on_definition.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_add_on_definition.id"}}`, encodeURIComponent(String(requestParameters.existingAddOnDefinitionId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateAddOnDefinitionBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateAddOnDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * UpdateAddOnDefinition updates an existing Add-on definition
     */
    async waypointServiceUpdateAddOnDefinition(namespaceId, existingAddOnDefinitionId, body) {
        const response = await this.waypointServiceUpdateAddOnDefinitionRaw({ namespaceId: namespaceId, existingAddOnDefinitionId: existingAddOnDefinitionId, body: body });
        return await response.value();
    }
    /**
     * UpdateAddOnDefinition updates an existing Add-on definition
     */
    async waypointServiceUpdateAddOnDefinition2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateAddOnDefinition2.');
        }
        if (requestParameters.existingAddOnDefinitionName === null || requestParameters.existingAddOnDefinitionName === undefined) {
            throw new runtime.RequiredError('existingAddOnDefinitionName', 'Required parameter requestParameters.existingAddOnDefinitionName was null or undefined when calling waypointServiceUpdateAddOnDefinition2.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateAddOnDefinition2.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/add-on-definition/by-name/{existing_add_on_definition.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_add_on_definition.name"}}`, encodeURIComponent(String(requestParameters.existingAddOnDefinitionName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateAddOnDefinitionBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateAddOnDefinitionResponseFromJSON(jsonValue));
    }
    /**
     * UpdateAddOnDefinition updates an existing Add-on definition
     */
    async waypointServiceUpdateAddOnDefinition2(namespaceId, existingAddOnDefinitionName, body) {
        const response = await this.waypointServiceUpdateAddOnDefinition2Raw({ namespaceId: namespaceId, existingAddOnDefinitionName: existingAddOnDefinitionName, body: body });
        return await response.value();
    }
    /**
     * UpdateAgentGroup updates an agent group.
     */
    async waypointServiceUpdateAgentGroupRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateAgentGroup.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling waypointServiceUpdateAgentGroup.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateAgentGroup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/group/{name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateAgentGroupBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateAgentGroupResponseFromJSON(jsonValue));
    }
    /**
     * UpdateAgentGroup updates an agent group.
     */
    async waypointServiceUpdateAgentGroup(namespaceId, name, body) {
        const response = await this.waypointServiceUpdateAgentGroupRaw({ namespaceId: namespaceId, name: name, body: body });
        return await response.value();
    }
    /**
     * UpdateApplication updates an existing application.
     */
    async waypointServiceUpdateApplicationRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplication.');
        }
        if (requestParameters.applicationId === null || requestParameters.applicationId === undefined) {
            throw new runtime.RequiredError('applicationId', 'Required parameter requestParameters.applicationId was null or undefined when calling waypointServiceUpdateApplication.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateApplication.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/{application.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.id"}}`, encodeURIComponent(String(requestParameters.applicationId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateApplicationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplication updates an existing application.
     */
    async waypointServiceUpdateApplication(namespaceId, applicationId, body) {
        const response = await this.waypointServiceUpdateApplicationRaw({ namespaceId: namespaceId, applicationId: applicationId, body: body });
        return await response.value();
    }
    /**
     * UpdateApplication updates an existing application.
     */
    async waypointServiceUpdateApplication2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplication2.');
        }
        if (requestParameters.applicationName === null || requestParameters.applicationName === undefined) {
            throw new runtime.RequiredError('applicationName', 'Required parameter requestParameters.applicationName was null or undefined when calling waypointServiceUpdateApplication2.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateApplication2.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/by-name/{application.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.name"}}`, encodeURIComponent(String(requestParameters.applicationName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateApplicationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplication updates an existing application.
     */
    async waypointServiceUpdateApplication2(namespaceId, applicationName, body) {
        const response = await this.waypointServiceUpdateApplication2Raw({ namespaceId: namespaceId, applicationName: applicationName, body: body });
        return await response.value();
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplateRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplicationTemplate.');
        }
        if (requestParameters.existingApplicationTemplateId === null || requestParameters.existingApplicationTemplateId === undefined) {
            throw new runtime.RequiredError('existingApplicationTemplateId', 'Required parameter requestParameters.existingApplicationTemplateId was null or undefined when calling waypointServiceUpdateApplicationTemplate.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateApplicationTemplate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates/{existing_application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_application_template.id"}}`, encodeURIComponent(String(requestParameters.existingApplicationTemplateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateApplicationTemplateBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate(namespaceId, existingApplicationTemplateId, body) {
        const response = await this.waypointServiceUpdateApplicationTemplateRaw({ namespaceId: namespaceId, existingApplicationTemplateId: existingApplicationTemplateId, body: body });
        return await response.value();
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate2Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplicationTemplate2.');
        }
        if (requestParameters.existingApplicationTemplateName === null || requestParameters.existingApplicationTemplateName === undefined) {
            throw new runtime.RequiredError('existingApplicationTemplateName', 'Required parameter requestParameters.existingApplicationTemplateName was null or undefined when calling waypointServiceUpdateApplicationTemplate2.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateApplicationTemplate2.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/application-templates/by-name/{existing_application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_application_template.name"}}`, encodeURIComponent(String(requestParameters.existingApplicationTemplateName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateApplicationTemplateBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate2(namespaceId, existingApplicationTemplateName, body) {
        const response = await this.waypointServiceUpdateApplicationTemplate2Raw({ namespaceId: namespaceId, existingApplicationTemplateName: existingApplicationTemplateName, body: body });
        return await response.value();
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate3Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplicationTemplate3.');
        }
        if (requestParameters.existingApplicationTemplateId === null || requestParameters.existingApplicationTemplateId === undefined) {
            throw new runtime.RequiredError('existingApplicationTemplateId', 'Required parameter requestParameters.existingApplicationTemplateId was null or undefined when calling waypointServiceUpdateApplicationTemplate3.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateApplicationTemplate3.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/{existing_application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_application_template.id"}}`, encodeURIComponent(String(requestParameters.existingApplicationTemplateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateApplicationTemplateBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate3(namespaceId, existingApplicationTemplateId, body) {
        const response = await this.waypointServiceUpdateApplicationTemplate3Raw({ namespaceId: namespaceId, existingApplicationTemplateId: existingApplicationTemplateId, body: body });
        return await response.value();
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate4Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplicationTemplate4.');
        }
        if (requestParameters.existingApplicationTemplateName === null || requestParameters.existingApplicationTemplateName === undefined) {
            throw new runtime.RequiredError('existingApplicationTemplateName', 'Required parameter requestParameters.existingApplicationTemplateName was null or undefined when calling waypointServiceUpdateApplicationTemplate4.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateApplicationTemplate4.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/by-name/{existing_application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_application_template.name"}}`, encodeURIComponent(String(requestParameters.existingApplicationTemplateName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateApplicationTemplateBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate4(namespaceId, existingApplicationTemplateName, body) {
        const response = await this.waypointServiceUpdateApplicationTemplate4Raw({ namespaceId: namespaceId, existingApplicationTemplateName: existingApplicationTemplateName, body: body });
        return await response.value();
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate5Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplicationTemplate5.');
        }
        if (requestParameters.existingApplicationTemplateId === null || requestParameters.existingApplicationTemplateId === undefined) {
            throw new runtime.RequiredError('existingApplicationTemplateId', 'Required parameter requestParameters.existingApplicationTemplateId was null or undefined when calling waypointServiceUpdateApplicationTemplate5.');
        }
        if (requestParameters.applicationTemplate === null || requestParameters.applicationTemplate === undefined) {
            throw new runtime.RequiredError('applicationTemplate', 'Required parameter requestParameters.applicationTemplate was null or undefined when calling waypointServiceUpdateApplicationTemplate5.');
        }
        const queryParameters = {};
        if (requestParameters.existingApplicationTemplateName !== undefined) {
            queryParameters['existing_application_template.name'] = requestParameters.existingApplicationTemplateName;
        }
        if (requestParameters.useModuleReadme !== undefined) {
            queryParameters['use_module_readme'] = requestParameters.useModuleReadme;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/{existing_application_template.id}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_application_template.id"}}`, encodeURIComponent(String(requestParameters.existingApplicationTemplateId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointApplicationTemplateToJSON(requestParameters.applicationTemplate),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate5(namespaceId, existingApplicationTemplateId, applicationTemplate, existingApplicationTemplateName, useModuleReadme) {
        const response = await this.waypointServiceUpdateApplicationTemplate5Raw({ namespaceId: namespaceId, existingApplicationTemplateId: existingApplicationTemplateId, applicationTemplate: applicationTemplate, existingApplicationTemplateName: existingApplicationTemplateName, useModuleReadme: useModuleReadme });
        return await response.value();
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate6Raw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateApplicationTemplate6.');
        }
        if (requestParameters.existingApplicationTemplateName === null || requestParameters.existingApplicationTemplateName === undefined) {
            throw new runtime.RequiredError('existingApplicationTemplateName', 'Required parameter requestParameters.existingApplicationTemplateName was null or undefined when calling waypointServiceUpdateApplicationTemplate6.');
        }
        if (requestParameters.applicationTemplate === null || requestParameters.applicationTemplate === undefined) {
            throw new runtime.RequiredError('applicationTemplate', 'Required parameter requestParameters.applicationTemplate was null or undefined when calling waypointServiceUpdateApplicationTemplate6.');
        }
        const queryParameters = {};
        if (requestParameters.existingApplicationTemplateId !== undefined) {
            queryParameters['existing_application_template.id'] = requestParameters.existingApplicationTemplateId;
        }
        if (requestParameters.useModuleReadme !== undefined) {
            queryParameters['use_module_readme'] = requestParameters.useModuleReadme;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/templates/by-name/{existing_application_template.name}`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"existing_application_template.name"}}`, encodeURIComponent(String(requestParameters.existingApplicationTemplateName))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointApplicationTemplateToJSON(requestParameters.applicationTemplate),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateApplicationTemplateResponseFromJSON(jsonValue));
    }
    /**
     * UpdateApplicationTemplate updates an existing application template.
     */
    async waypointServiceUpdateApplicationTemplate6(namespaceId, existingApplicationTemplateName, applicationTemplate, existingApplicationTemplateId, useModuleReadme) {
        const response = await this.waypointServiceUpdateApplicationTemplate6Raw({ namespaceId: namespaceId, existingApplicationTemplateName: existingApplicationTemplateName, applicationTemplate: applicationTemplate, existingApplicationTemplateId: existingApplicationTemplateId, useModuleReadme: useModuleReadme });
        return await response.value();
    }
    /**
     * UpdateTFCConfig updates a Terraform Cloud configuration
     */
    async waypointServiceUpdateTFCConfigRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateTFCConfig.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateTFCConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/tfcconfig`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateTFCConfigBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateTFCConfigResponseFromJSON(jsonValue));
    }
    /**
     * UpdateTFCConfig updates a Terraform Cloud configuration
     */
    async waypointServiceUpdateTFCConfig(namespaceId, body) {
        const response = await this.waypointServiceUpdateTFCConfigRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     */
    async waypointServiceUpdateVariableRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpdateVariable.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpdateVariable.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/variable`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpdateVariableBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpdateVariableResponseFromJSON(jsonValue));
    }
    /**
     */
    async waypointServiceUpdateVariable(namespaceId, body) {
        const response = await this.waypointServiceUpdateVariableRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
    /**
     * UpgradeApplicationTFWorkspace upgrades the application\'s Terraform workspace to the pinned version of the no-code module used to provision the application infrastructure.
     */
    async waypointServiceUpgradeApplicationTFWorkspaceRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceUpgradeApplicationTFWorkspace.');
        }
        if (requestParameters.applicationName === null || requestParameters.applicationName === undefined) {
            throw new runtime.RequiredError('applicationName', 'Required parameter requestParameters.applicationName was null or undefined when calling waypointServiceUpgradeApplicationTFWorkspace.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceUpgradeApplicationTFWorkspace.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/applications/{application.name}/upgrade-tf-workspace`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))).replace(`{${"application.name"}}`, encodeURIComponent(String(requestParameters.applicationName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceUpgradeApplicationTFWorkspaceBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointUpgradeApplicationTFWorkspaceResponseFromJSON(jsonValue));
    }
    /**
     * UpgradeApplicationTFWorkspace upgrades the application\'s Terraform workspace to the pinned version of the no-code module used to provision the application infrastructure.
     */
    async waypointServiceUpgradeApplicationTFWorkspace(namespaceId, applicationName, body) {
        const response = await this.waypointServiceUpgradeApplicationTFWorkspaceRaw({ namespaceId: namespaceId, applicationName: applicationName, body: body });
        return await response.value();
    }
    /**
     * ValidateAgentGroups is called by the agent on startup to check that the groups it is listening on are valid groups.
     */
    async waypointServiceValidateAgentGroupsRaw(requestParameters) {
        if (requestParameters.namespaceId === null || requestParameters.namespaceId === undefined) {
            throw new runtime.RequiredError('namespaceId', 'Required parameter requestParameters.namespaceId was null or undefined when calling waypointServiceValidateAgentGroups.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling waypointServiceValidateAgentGroups.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/waypoint/2023-08-18/namespace/{namespace.id}/agent/group:validate`.replace(`{${"namespace.id"}}`, encodeURIComponent(String(requestParameters.namespaceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudWaypointWaypointServiceValidateAgentGroupsBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudWaypointValidateAgentGroupsResponseFromJSON(jsonValue));
    }
    /**
     * ValidateAgentGroups is called by the agent on startup to check that the groups it is listening on are valid groups.
     */
    async waypointServiceValidateAgentGroups(namespaceId, body) {
        const response = await this.waypointServiceValidateAgentGroupsRaw({ namespaceId: namespaceId, body: body });
        return await response.value();
    }
}
